import React from 'react'
import VoyahDreamHero from '../../components/pages/VoyahDream/VoyahDreamHero/VoyahDreamHero'
import VoyahDreamWarranty from '../../components/pages/VoyahDream/VoyahDreamWarranty/VoyahDreamWarranty'
import VdExteriorInterior from '../../components/pages/VoyahDream/VdExteriorInterior/VdExteriorInterior'
import VdFeatures from '../../components/pages/VoyahDream/VdFeatures/VdFeatures'
import Footer2 from '../../components/pages/VoyahFree/Footer2'
import BackToVehicleModels from '../../components/BackToVehicleModels/BackToVehicleModels'
import VoyahDreamExtras from '../../components/pages/VoyahDream/VoyahDreamExtras/VoyahDreamExtras'
import VoyahDreamTechnicalSpecs from '../../components/pages/VoyahDream/VoyahDreamTechnicalSpecs/VoyahDreamTechnicalSpecs'

const VoyahDream = () => {
  return (
    <div>
        <VoyahDreamHero />
        <VoyahDreamTechnicalSpecs />
        <VoyahDreamWarranty />
        <VdExteriorInterior />
        <VoyahDreamExtras />
        <VdFeatures />
        <BackToVehicleModels variant="light" />
        <Footer2/>
    </div>
  )
}

export default VoyahDream